export const DESCRIPTOR_PERSONALITY = 0;
export const DESCRIPTOR_COGNITION = 1;

export const questionDescriptorOptions = [
  { text: 'Personality', value: DESCRIPTOR_PERSONALITY },
  { text: 'Cognition', value: DESCRIPTOR_COGNITION },
];
